rkcApp.factory('toastService', ['$mdToast', function ($mdToast) {
    var shinyService = {
        toastPosition: undefined,
        getToastPosition: undefined,
        showSimpleToast: undefined,
        showActionToast: undefined,
        parseError: undefined,
        closeToast: undefined,
        showReturnToast: undefined
    };
    var last = {
        bottom: true,
        top: false,
        left: true,
        right: false
    };
    shinyService.toastPosition = angular.extend({}, last);
    shinyService.getToastPosition = function () {
        sanitizePosition();
        return Object.keys(shinyService.toastPosition).filter(function (pos) {
            return shinyService.toastPosition[pos];
        }).join(' ');
    };

    function sanitizePosition() {
        var current = shinyService.toastPosition;
        if (current.bottom && last.top) current.top = false;
        if (current.top && last.bottom) current.bottom = false;
        if (current.right && last.left) current.left = false;
        if (current.left && last.right) current.right = false;
        last = angular.extend({}, current);
    }

    shinyService.showSimpleToast = function (text, delay) {
        var pinTo = shinyService.getToastPosition();
        $mdToast.show($mdToast.simple()
            .textContent(text)
            .position(pinTo)
            .hideDelay(delay)
        );
    };
    shinyService.showActionToast = function (text, action, func, delay) {
        var pinTo = shinyService.getToastPosition();
        var toast = $mdToast.simple()
            .textContent(text)
            .action(action)
            .highlightAction(true)
            .position(pinTo)
            .hideDelay(delay);
        $mdToast.show(toast).then(function (response) {
            if (response == 'ok' && angular.isFunction(func)) {
                func();
            }
        });
    };

    shinyService.showReturnToast = function (text, delay) {
        var pinTo = shinyService.getToastPosition();
        var toast = $mdToast.simple()
            .textContent(text)
            .action("Tilbake")
            .highlightAction(true)
            .position(pinTo)
            .hideDelay(delay)
        ;
        $mdToast.show(toast).then(function (response) {
            if (response == 'ok') {
                window.history.back();
            }
        });
    };

    shinyService.parseError = function (error) {
        if (!error) {
            shinyService.showSimpleToast("Noe gikk galt", 3000);
            return;
        }

        if (error.status === 409) {
            shinyService.showActionToast("Dataen sendt inn gav en konflikt. Forsikre deg at alle nødvendige felter er fyllt ut.", 'Ok', {}, 0);
        }
        else if (error.status === 403) {
            shinyService.showActionToast("Du har ikke rettighet til dette.", 'Ok', {}, 0);
        }
        else if (error.status === 400) {
            const message = error.data ? error.data.message ? error.data.message : error.statusText : 'Noe gikk galt';
            shinyService.showActionToast(message + " Httpkode: " + error.status, 'Ok', {}, 0);
        }
        else if (error.status !== 401) {
            const message = error.data ? error.data.message ? error.data.message : error.statusText : 'Noe gikk galt';
            shinyService.showActionToast("Det forekom en feil. Respons: " + error.status + " " + message, 'Ok', {}, 0);
        }
    };

    shinyService.closeToast = function () {
        $mdToast.hide();
    };

    return shinyService;
}]);



/** WEBPACK FOOTER **
 ** ./src/app/services/toastService.ts
 **/